import { CONFIGURATION_AGENT_ID } from "@repo/app-types/entities/configurationAgent";
import type { FC, ReactNode } from "react";
import { MastraChatProvider } from "../mastra/mastraChatContext.js";
import { useMastraChat } from "../mastra/useMastraChat.js";

export interface ConfigurationAssistantProviderProps {
  teammateAgentId: string;
  children?: ReactNode;
}

export const ConfigurationAssistantProvider: FC<
  ConfigurationAssistantProviderProps
> = (props) => {
  const chat = useMastraChat({
    agentId: CONFIGURATION_AGENT_ID,
    onSend: async () => ({
      requestContext: {
        teammateAgentId: props.teammateAgentId,
      },
    }),
  });

  return <MastraChatProvider chat={chat}>{props.children}</MastraChatProvider>;
};
